import type { UserRole } from '@mairistem/finances-utils';
import React from 'react';

// Role de l'utilisateur, recupere par le Context. Il est publie ici plutot que
// dans un contexte React car les menus sont declares dans AppSimulation, en
// dehors du Context (qui n'enrobe que le contenu des features, eventuellement
// dans une autre racine React)
let userRoleCourant: UserRole | undefined;
const abonnes = new Set<() => void>();

export const setUserRoleCourant = (userRole: UserRole) => {
	if (userRoleCourant === userRole) return;

	userRoleCourant = userRole;
	abonnes.forEach((abonne) => {
		abonne();
	});
};

const subscribe = (abonne: () => void) => {
	abonnes.add(abonne);

	return () => {
		abonnes.delete(abonne);
	};
};

const getSnapshot = () => userRoleCourant;

export const useUserRoleCourant = () =>
	React.useSyncExternalStore(subscribe, getSnapshot);
